export default __webpack_public_path__ + "static/media/StephanieCarrero.b904d092.JPG";